import { ENVIRONMENT } from './environments/environment';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { defineCustomElements } from '@lealco/system-design/loader';

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));

if (ENVIRONMENT.useDesignsystem) {
  defineCustomElements(window, {
    transformTagName: (tagName: string) => `shell-${tagName}`,
  } as any)
}


